import { TimeEdit } from "../lib/TimeEdit";
import React from "react";
import { TComponent } from "../types/utils";

type TCalendarIconProps = {
    /** Calendar model; matched against the active view's sections by `_modelId`. */
    calendar: any;
    /** Icon edge length in pixels. */
    size: number;
    isActive: boolean;
};

const CalendarIcon: TComponent<TCalendarIconProps> = (props) => {
    const getSize = (section, x = 0, y = 0, width = 1.0, height = 1.0) => {
        if (section.hasChild()) {
            if (section.first._modelId !== props.calendar._modelId) {
                return null;
            }

            const FRAME = 4;
            const EDGE = 2;
            const sizeExcludingFrame = props.size - FRAME;
            return {
                x: x * sizeExcludingFrame + EDGE,
                y: y * sizeExcludingFrame + EDGE,
                width: width * sizeExcludingFrame,
                height: height * sizeExcludingFrame,
            };
        }

        if (section.hasVerticalLayout) {
            return (
                getSize(section.first, x, y, width, height * section.weight) ||
                getSize(
                    section.second,
                    x,
                    y + height * section.weight,
                    width,
                    height * (1 - section.weight)
                )
            );
        }

        return (
            getSize(section.first, x, y, width * section.weight, height) ||
            getSize(
                section.second,
                x + width * section.weight,
                y,
                width * (1 - section.weight),
                height
            )
        );
    };

    const renderCalendar = () => {
        const view = TimeEdit.State.get()!.view;
        const size = getSize(view!.section);
        const classes = ["calendarIcon"];
        if (props.isActive) {
            classes.push("active");
        }

        return (
            <rect
                x={size.x}
                y={size.y}
                width={size.width}
                height={size.height}
                rx="3"
                ry="3"
                className={classes.join(" ")}
            />
        );
    };

    return (
        <svg
            className="calendarIcon"
            width={props.size}
            height={props.size}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
                rx="5"
                ry="5"
                className="calendarIconBackground"
            />
            {renderCalendar()}
        </svg>
    );
};

export default CalendarIcon;
